import { createSlice } from "@reduxjs/toolkit";
import { transformKeys } from "../../_helper";

const initialState = {
  accountsReviewData: [],
  isLoading: false,
  error: "",
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0,
  },
};

export const AccountsReviewSlice = createSlice({
  name: "AccountsReviewList",
  initialState,
  reducers: {
    setAccountsReviewData: (state, action) => {
      const transformedData = action.payload.data.map(transformKeys);

      state.accountsReviewData = transformedData;
      state.pagination = action.payload.paginator;
    },
    clearAccountsReviewData: (state) => {
      state.accountsReviewData = [];
      state.pagination = {
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0,
      };
    },
    catchError: (state, action) => {
      state.error =
        action.payload.message ||
        "un expected error while fetching accounts data";
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setAccountsReviewData,
  clearAccountsReviewData,
  catchError,
  setLoading,
} = AccountsReviewSlice.actions;
export default AccountsReviewSlice.reducer;
